import React from "react";
import { format } from "date-fns";
import classnames from "classnames";

import { makeStyles } from "@material-ui/styles";
import InfoIcon from "@material-ui/icons/Info";

import { PageHeader, PageFooter, BackButton } from "jazasoft";

import MuiTable from "../../../../components/MuiTable";
import { useDeepMemo, useQuery, useSafeState } from "../../../../hooks";

import InfoDrawer from "../../../system-activity/details/ActivityDetailsDrawer";
import { isEmpty } from "../../../../utils/helpers";

const columns = [
  { dataKey: "entityName", title: "Entity Name" },
  { dataKey: "event", title: "Event" },
  { dataKey: "searchText", title: "Entity Value" },
  { dataKey: "createdAt", title: "Time" },
  { dataKey: "createdBy", title: "User" }
];

const useStyles = makeStyles(theme => ({
  root: {}
}));

const OrderHistory = props => {
  const classes = useStyles();

  const [drawerState, setDrawerState] = useSafeState({ open: false, userActivity: null });

  const orderId = props?.match?.params?.id;
  const { data: activityList = [] } = useQuery({
    url: "system-activities",
    params: { search: `type=='USER';entityName=='Order';entityId==${Number(orderId)}`, sort: "id,desc" }
  });

  const rows = useDeepMemo(() => {
    if (isEmpty(activityList)) return [];
    return activityList.map(h => ({ ...h, createdAt: format(h.createdAt, "dd MMM, yyyy HH:mm a") }));
  }, [activityList]);

  const onInfoClick = (event, action, row, onActionComplete) => {
    setDrawerState({ open: true, userActivity: row });
  };

  return (
    <div className={classnames(classes.root)}>
      <PageHeader title="Order History" />

      <InfoDrawer
        open={drawerState?.open || false}
        userActivity={drawerState?.userActivity}
        onDrawerClose={() => setDrawerState({ open: false, userActivity: null })}
      />

      <div style={{ padding: "1.5rem", paddingTop: 0 }}>
        <MuiTable
          rows={rows}
          columns={columns}
          inlineActions={[{ name: "info", tooltip: "Info", icon: <InfoIcon />, align: "center" }]}
          onInlineActionClick={onInfoClick}
        />

        <PageFooter>
          <BackButton variant="contained" className={classes.button} />
        </PageFooter>
      </div>
    </div>
  );
};

export default OrderHistory;
